import {useGoVehisService} from "../../utils/axios";
import {useEffect, useState} from "react";
import {Button, Snackbar, Table, TableBody} from "@material-ui/core";
import TableRow from "@material-ui/core/TableRow";
import TableHead from "@material-ui/core/TableHead";
import TableCell from "@material-ui/core/TableCell";

function AkolLogsList() {
  const goVehisService = useGoVehisService();
  const [logs, setLogs] = useState([])
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  useEffect(() => {
    goVehisService.get("/admin/akol/logs").then(
      res => setLogs(res.data)
    )
  }, [])

  const handleReimport = (fileName) => {
    goVehisService.post("/admin/akol/reimport", fileName, {
      headers: {
        'Content-Type': 'text/plain'
      }
    }).then((res) => {
      setSnackbarMessage(res.data);
      setSnackbarOpen(true);
    }).catch((error) => {
      setSnackbarMessage((error.response?.data || error.message));
      setSnackbarOpen(true);
    })
  }

  return (
    <>
      <Snackbar
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
      />
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Id</TableCell>
            <TableCell>Komunikat</TableCell>
            <TableCell>Czas</TableCell>
            <TableCell>Akcje</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {
            logs.map((log) => (
              <TableRow key={log.id}>
                <TableCell>{log.id}</TableCell>
                <TableCell>{log.message}</TableCell>
                <TableCell>{new Date(log.time).toLocaleString()}</TableCell>
                <TableCell>
                  {log.filename && <Button
                    variant="contained"
                    color="primary"
                    onClick={() => handleReimport(log.filename)}
                  >
                    Powtórz import
                  </Button>}
                </TableCell>
              </TableRow>
            ))
          }
        </TableBody>
      </Table>
    </>
  )
}

export default AkolLogsList;
